import React, { useState, useRef, useEffect } from "react";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import axios from "../api/axios";
import { Fieldset } from "primereact/fieldset";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Dropdown } from "primereact/dropdown";
import { Timeline } from "primereact/timeline";
import { axiosPrivate } from "../api/axios";
import { ProgressSpinner } from "primereact/progressspinner";

const pasosZIP = [
  {
    status: "1",
    date: "Comprima todos los xml del bimestre sin el PDF, seleccione el archivo .zip que desea cargar al bimestre.",
  },
  {
    status: "2",
    date: "La carga del archivo iniciara de manera automatica.",
  },
  {
    status: "3",
    date: "El finalizar la carga de clic en finalizar para generar los reportes.",
  },
];
const CFDIs = ({ Auth }) => {
  const toast = useRef(null);
  const stepperRef = useRef(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedBimestre, setSelectedBimestre] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [selectedEmpresa, setSeleccionado] = useState(null);
  const [zipCargado, setZipCargado] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileUploadRef = useRef(null);
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const datosTransformados = Auth.Empresas.map((item) => ({
          label: item.nombre,
          value: item.rfc,
        }));
        setOpciones(datosTransformados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    fetchEmpresas();
  }, []);

  const years = [{ name: "2025", code: "2025" }];

  const bimestres = [
    { name: "01", code: "01" },
    { name: "02", code: "02" },
    { name: "03", code: "03" },
    { name: "04", code: "04" },
    { name: "05", code: "05" },
    { name: "06", code: "06" },
  ];
  const ValidarForm = () => {
    if (selectedEmpresa === null) {
      showMessage("error", "Error", "Seleccione la empresa.");
      return false;
    }
    if (selectedYear === null) {
      showMessage("error", "Error", "Seleccione el año.");
      return false;
    }
    if (selectedBimestre === null) {
      showMessage("error", "Error", "Seleccione el bimestre.");
      return false;
    }
    return true;
  };
  const showMessage = (tipo, titulo, msg) => {
    toast.current.show({ severity: tipo, summary: titulo, detail: msg });
  };

  const uploadXMLs = async ({ files }) => {
    if (ValidarForm() === false) return;

    const invoiceFile = files[0];
    const formData = new FormData();
    formData.append("archivoZIP", invoiceFile);
    formData.append("year", selectedYear.code);
    formData.append("bimestre", selectedBimestre.code);
    formData.append("rfc", selectedEmpresa);

    setIsUploading(true);
    try {
      const response = await axiosPrivate.post("SUA/uploadZIP", formData);
      console.log(response);
      if (response.status === 200) {
        showMessage("info", "Completado", response.data.message);
        setZipCargado(true);
        if (fileUploadRef.current) {
        fileUploadRef.current.clear();
      }
      }
    } catch (error) {
      showMessage("error", "Error", error.error);
      setZipCargado(false);
    } finally {
      setIsUploading(false);
    }
  };
  return (
    <>
      <h1>Recibo de nómina</h1>
      <Toast ref={toast}></Toast>
      <Fieldset legend="Instrucciones">
        <ul>
          <li>Seleccione la empresa, el año y bimestre que desea cargar.</li>
          <li>
            Para cargar los recibos de nomina comprima los archivos .xml en un
            archivo .zip{" "}
          </li>
        </ul>
      </Fieldset>
      <div className="card flex justify-content-center">
        <div className="flex flex-column gap-2 mr-2">
          <label htmlFor="empresa">Empresa</label>
          <Dropdown
            id="empresa"
            value={selectedEmpresa}
            options={opciones}
            onChange={(e) => setSeleccionado(e.value)}
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione la empresa"
            className="w-full md:w-25rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Año</label>
          <Dropdown
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.value)}
            options={years}
            optionLabel="name"
            placeholder="Seleccione el año"
            className="w-full md:w-16rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Bimestre</label>
          <Dropdown
            value={selectedBimestre}
            onChange={(e) => setSelectedBimestre(e.value)}
            options={bimestres}
            optionLabel="name"
            placeholder="Seleccione el bimestre"
            className="w-full md:w-16rem"
          />
          <small id="username-help"></small>
        </div>
      </div>
      <div className="card flex justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: "80rem" }} linear>
          <StepperPanel header="Recibos del bimestre">
            <div className="flex flex-column h-25rem">
              <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                <Fieldset className="flex-auto h-25rem">
                  <div className="h-full overflow-y-auto px-2">
                    <Timeline
                      value={pasosZIP}
                      opposite={(item) => item.status}
                      content={(item) => (
                        <small className="text-color-secondary">
                          {item.date}
                        </small>
                      )}
                    />

                    <div className="flex w-full justify-content-center my-3 " >
                      <FileUpload
                       ref={fileUploadRef}
                        name="filesXML[]"
                        accept=".zip"
                        maxFileSize={900000000}
                        customUpload
                        uploadHandler={uploadXMLs}
                        chooseLabel="Seleccionar .zip"
                        uploadLabel="Subir"
                        cancelLabel="Cancelar"
                        mode="advanced"
                        multiple={false}
                        disabled={isUploading}
                        className="w-full justify-center-buttons "
                      />
                    </div>

                    {isUploading && (
                      <div className="flex justify-content-center my-3">
                        <ProgressSpinner
                          style={{ width: "50px", height: "50px" }}
                        />
                      </div>
                    )}
                  </div>
                </Fieldset>
              </div>
            </div>            
          </StepperPanel>          
        </Stepper>
      </div>
    </>
  );
};
export default CFDIs;
